import React from "react";
import Modal from "react-bootstrap/Modal";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import Switch from "components/GenericComponent/Switch";
class NguonKhachHang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      isOn: false,
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };
  onHide = () => {
    let props = this.props;
    props.onHide();
  };
  onChangeSwitch = () => {
    let { isOn } = this.state;
    this.setState({ isOn: !isOn });
  };
  renderTableRows() {
    let { isOn } = this.state;
    let List = [{}, {}];
    return List.map((item, index) => (
      <div className="custom-table-row" key={"item" + index}>
        <div className="row-show-three">
          <div className="row-mobile">
            <div className="custom-table-cell flex-basis-65">
              <span className="mobile-column-name disk-mobile">
                Nguồn khách hàng
              </span>
              <div className="center-wrapper">
                <p className="text-left">
                  {" "}
                  <input
                    type="text"
                    className="form-control input-sm w-input-config"
                    value="Thu tiền phát sinh"
                  />
                </p>
              </div>
            </div>

            <div className="custom-table-cell flex-basis-20 flex-disk">
              <span className="mobile-column-name disk-mobile">Tiền lãi</span>
              <div className="center-wrapper-switch">
                <Switch isOn={isOn} handleToggle={this.onChangeSwitch} />
              </div>
            </div>
          </div>

          <div className="custom-table-cell flex-basis-15  sticky-icon ">
            <div className="center-wrapper">
              <div className="iconTableMorman">
                <a href={() => false}>
                  <PopoversBootrap
                    contentText="Lưu"
                    titleText=""
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i class="mdi mdi-content-save"></i>
                  </PopoversBootrap>
                </a>
                <a href={() => false}>
                  <PopoversBootrap
                    contentText="Xoá"
                    titleText=""
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i className="mdi mdi-delete"></i>
                  </PopoversBootrap>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  }

  render() {
    let props = this.props;

    return (
      <Modal
        {...props}
        size="modal-size-50 modal-size-50"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-account-group"></i>
            </span>
            Nguồn khách hàng
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>

        <Modal.Body className="">
          <form className="tat-toan">
            <div className="form-body">
              <div className="row">
                <div className="col-md-5">
                  <div className="form-group">
                    <label for="projectinput1">Tên nguồn khách hàng</label>
                    <input type="text" className="form-control input-sm" />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-actions text-left t-button">
                    <button
                      type="button"
                      className="btn btn-new-main btn-checknew"
                    >
                      <span className="btn-icon-left">
                        <i className="mdi mdi-plus"></i>
                      </span>{" "}
                      Thêm
                    </button>
                  </div>
                </div>
              </div>

              <div className="Left-table mt-1">
                <div className="Left808x200 Table-main-new table-mobile-new table-mobile-new-border add-customer">
                  <div className="table-responsive table-responsive-new table-new1 ">
                    <div className="custom-table-wrapper">
                      <div className="table-headers">
                        <div className="custom-table-header flex-basis-65 ">
                          <p>Nguồn khách hàng</p>
                        </div>
                        <div className="custom-table-header flex-basis-20 ">
                          <p className="tab-header text-center">Active</p>
                        </div>
                        <div className="custom-table-header flex-basis-15 ">
                          <p className="tab-header text-center">Thao tác</p>
                        </div>
                      </div>

                      <div className="custom-table-body">
                        <div className="custom-table-row">
                          <div className="custom-table-cell username-cell-mobile flex-basis-5 disk-desktop show-mobile">
                            <span className="mobile-column-name">
                              Nguồn khách hàng
                            </span>
                            <div className="center-wrapper">
                              <p className="text-left">Active</p>
                            </div>
                          </div>
                        </div>
                        {this.renderTableRows()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" className="btn btn-new-main btn-checknew">
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Lưu
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={this.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default NguonKhachHang;
